import { userService } from "../modules/api_client";
import type { UserDto } from "../api";
import { isPublicPath } from "../common/routes/route_utils";
import { useApi } from "./useApi";

export function useMe({
  refreshInterval = 0,
}: { refreshInterval?: number } = {}) {
  const isPublic = isPublicPath(window.location.pathname);

  const {
    data: user,
    mutate,
    isLoading,
    error,
  } = useApi<UserDto>("me", () => userService.getMe(), {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshInterval: refreshInterval,
    revalidateIfStale: !isPublic,
    revalidateOnMount: true,
    shouldRetryOnError: !isPublic,
  });

  return { user, mutate, isLoading, error };
}
